import React, { useEffect, useState } from 'react'
import ReactLoading from 'react-loading'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../service/ApiService'
import { Modal } from '../../Shared/Modal'
import { AboutUsContent, AboutUsLoading } from './styles'

export const AboutUsModal = ({ open, onClose }) => {
  const { t } = useTranslation()
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)
  const currentLng = localStorage.getItem('i18nextLng') || 'ar'

  useEffect(() => {
    if (!open) return

    const fetchAboutUs = async () => {
      setLoading(true)
      const res = await ApiService('/about_us', {}, 'get')
      if (res?.success) {
        setContent(currentLng === 'en' ? res.about_en : res.about_ar)
      } else {
        setContent('')
      }
      setLoading(false)
    }

    fetchAboutUs()
  }, [open, currentLng])

  const modalContent = (
    <AboutUsContent>
      {loading ? (
        <AboutUsLoading>
          <ReactLoading type="bubbles" color="#9c5a2e" height={50} width={50} />
        </AboutUsLoading>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </AboutUsContent>
  )

  return (
    <Modal
      open={open}
      title={t('About Us')}
      onClose={onClose}
      closeOnBackdrop
      width="720px"
      padding="20px 24px"
    >
      {modalContent}
    </Modal>
  )
}
